import { createAction, props } from "@ngrx/store";
import { AccessYourSuperEmployerDetailsSubmissionModel } from "src/app/model/access-your-super-form.models";

export const ResetComponentStateAction = createAction('[Access your super last employer component] reset state');

export const SaveLastEmployerDetailsAction = createAction('[Access your super last employer component] save form data', props<{accountId:number, applicationId: number, lastEmployerDetails:AccessYourSuperEmployerDetailsSubmissionModel}>())
export const LastEmployerDetailsSavedAction = createAction('[Access your super last employer component] saved form data');
